import PropTypes from "prop-types"

import { to_currency } from "helpers/number"

const AddonPrice = ({ price, retail_price }) => {
  return (
    <div className="body-sm mb-8 flex gap-8 font-semibold">
      <p className="text-emerald">{to_currency(price)}</p>
      <p className="text-grey-300">
        <strike>{to_currency(retail_price)}</strike>
      </p>
      {retail_price > price && (
        <p className="text-emerald">
          SAVE {Math.floor(((retail_price - price) / retail_price) * 100)}%
        </p>
      )}
      {/* <div
        className="bg-grey-20 tablet:mx-8 h-(--base-height) tablet:h-(--tablet-height) mx-4"
        style={{
          "--base-height": "24px",
          "--tablet-height": "35px",
          width: "1px",
        }}
      />
      <div className="flex flex-col items-start justify-center">
        <p className="text-12 tracking-tigher leading-14 font-medium">
          Retail: <strike>{to_currency(retail_price)}</strike>
        </p>
        <p className="text-12 tracking-tigher leading-14 text-sale font-medium">
          Save: {to_currency(retail_price - price)}
        </p>
      </div> */}
    </div>
  )
}

AddonPrice.propTypes = {
  price: PropTypes.number,
  retail_price: PropTypes.number,
}

export default AddonPrice
